const rediologyTest=[
    {
   
       test:"U/S Whole Abdomen-Female",  
       price: 1400,
       id: 1,
    },

    {
       
        test:"U/S Whole Abdomen-Male",  
        price: 1400,
        id: 2
     },
     {
    
        test:"U/S Upper Abdomen (Only Fasting )",  
        price: 1000,
        id: 3
     },
     {
      test:"U/S Kub ( Female) ( Full Bladder )",  
      price: 1000,
      id: 4
   },
   {
      test:"U/S Kub & Prostate ( Full Bladder )",  
      price: 1000,
      id: 5
   },
   {
      test:"U/S Pelvis ( Full Bladder )",  
      price: 1000,
      id: 6
   },
   {
      test:"U/S Fetal Well Being ( Ist Trimester, Full Bladder)",  
      price: 1000,
      id: 7
   },
   {
      test:"U/S Nuchal Thickness & Nasal Bone",  
      price: 1800,
      id: 8
   },

     {
     test:"U/S Level Ii Obstreteric",  
     price: 2700,
     id: 9
  },
  {
      test:"U/S Biophysical Score ( 3rd Trimester )",  
      price: 1650,
      id: 10
   },
   {
      test:"U/S Twin Pregnancy ( >12 Weeks)",  
      price: 1850,
      id: 11
   },
   {
      test:"U/S Twin Pregnancy Level Ii",  
      price: 4100,
      id: 12
   },

     {
     test:"U/S Twin Pregnancy Biophysical Score",  
     price: 2700,
     id: 13
  },
    {
     test:"U/S Transvaginal ( Tvs)",  
     price: 1500,
     id:14
  },
  {
      test:"U/S Follicular Studies",  
      price: 2300,
      id: 15,
   },
   {
      test:"U/S Follicular Studies , Single Sitting",  
      price: 850,
      id: 16,
   },
   {
      test:"U/S Transrectal ( Trus )",  
      price: 1600,
      id: 17
   },

   {
      test:"U/S Breast ( Both )",  
      price: 2100,
      id: 18
   },

     {
     test:"U/S Breast ( Single )",  
     price: 1050,
     id: 19
  },
  {
      test:"U/S Post Void Residual Volume (Full Bladder )",  
      price: 315,
      id: 20
   },
  {
      test:"U/S Additional Tvs",  
      price: 525,
      id: 21
   },
  {
      test:"U/S Chest",  
      price: 850,
      id:22
   },
  {
      test:"U/S Fetal Well Being ( Ii-Iii Trimester",  
      price: 1300,
      id: 23
   },
  {
      test:"U/S Testis",  
      price: 1300,
      id: 24
   },
  {
      test:"U/S Confirmation Of Pregnancy",  
      price: 950,
      id: 25
   },

  {
      test:"U/S Thyroid",  
      price: 1450,
id: 26
   },
  {id:27,
      test:"U/S Parotid (Salivary Gland )",  
      price: 1785
   },
  {
     id: 28,
      test:"U/S Sub Mandibular (Salivary Gland )",  
      price: 1785 
   },
  {id: 29,
      test:"U/S Small Parts",  
      price:1650
   },
  {
     id: 30,
      test:"U/S Screening Usg",  
      price: 600
   },
  {id: 31,
      test:"U/S Scrotal Doppler",  
      price: 2500
   },
  {id: 32,
      test:"U/S Obsteteric Doppler",  
      price: 2650
   },
  {id:33, 
      test:"U/S Twin Pregnancy - Dopler",  
      price: 4100
   },
  {id: 34,
      test:"U/S Cartoid Doppler",  
      price: 2800
   },
  {id: 35,
      test:"U/S Peripheral Arterial Doppler ( Single Limb)",  
      price: 2450
   },
  {id: 36,
      test:"U/S Peripheral Arterial Doppler ( Both Limbs)",  
      price: 4200
   },
  {id: 37,
      test:"U/S Peripheral Venous Doppler (Single Limb)",  
      price: 2450
   },
  {id: 38,
      test:"U/S Peripheral Venous Doppler (Both Limbs)",  
      price: 4200
   },
  {id: 39,
      test:"U/S Peripheral Arterial & Venous Doppler (Single Limb)",  
      price: 3800
   },
  {id: 40,
      test:"U/S Peripheral Arterial & Venous Doppler (Both Limbs)",  
      price: 7800
   },
  {id: 41,
      test:"U/S Renal Doppler (Fasting )",  
      price: 3150
   },
  {id: 42,
      test:"U/S Pelvic Doppler",  
      price: 2950
   },
  {id: 43,
      test:"U/S Aorto Femoral Doppler (Fasting)",  
      price: 2950
   },
  {id: 44,
      test:"U/S Splenoportal Doppler (Fasting)",  
      price: 2950
   },
  {id: 45,
      test:"U/S Colour Doppler Abdominal For Aorta & Branches",  
      price: 1950
   },
  {id: 46,
      test:"X-Ray Chest (Pa)",  
      price:375
   },
  {id: 47,
      test:"X-Ray Chest (Ap)",  
      price: 375
   },
  {id: 48,
      test:"X-Ray Chest ( R Lat)",  
      price: 375
   },
  {id: 49,
      test:"X-Ray Chest ( L Lat )",  
      price: 375
   },
  {id: 50,
      test:"X-Ray Chest ( R Lat Decubitus )",  
      price: 375
   },
  {id: 51,
      test:"X-Ray Chest ( L Lat Decubitus )",  
      price: 375
   },
  {id: 52,
      test:"X-Ray Chest (O)",  
      price: 375
   },
  {id: 53,
      test:"X-Ray Apicogram",  
      price: 375
   },
  {id: 54,
      test:"X-Ray Chest (Pa & Lat)",  
      price: 750
   },
  {id: 55,
      test:"X-Ray Chest Pa With Apicogram",  
      price: 750
   },
  {id: 56,
      test:"X-Ray Chest (Ap & Lat)",  
      price: 750
   },
  {id: 57,
      test:"X-Ray Cervical Spine ( Ap )",  
      price: 750
   },
  {id: 58,
      test:"X-Ray Cervical Spine ( R Lat)",  
      price: 375
   },
  {id: 59,
      test:"X-Ray Cervical Spine ( L Lat)",  
      price: 375
   },
  {id: 60,
      test:"X-Ray Cervical Spine ( Ro)",  
      price: 375
   },
  {id: 61,
      test:"X-Ray Cervical Spine ( Lo)",  
      price: 375
   },
  {id: 62,
      test:"X-Ray Cervical Spine Flexion / Extension",  
      price: 750
   },
  {id: 63,
      test:"X-Ray Thoracic Spine (Ap)",  
      price: 375
   },
  {id: 64,
      test:"X-Ray Thoracic Spine (L Lat)",  
      price: 375
   },
  {id: 65,
      test:"X-Ray Thoracic Spine (R Lat)",  
      price: 375
   },
  {id: 66,
      test:"X-Ray Thoraco Lumbar ( Ap ) / Dorso Lumbar Spine",  
      price: 375
   },
  {id: 67,
      test:"X-Ray Thoraco Lumbar ( R Lat ) / Dorso Lumbar Spine",  
      price: 375
   },
  {id: 68,
      test:"X-Ray Thoraco Lumbar ( L Lat ) / Dorso Lumbar Spine",  
      price: 375
   },
  {id: 69,
      test:"X-Ray Lumbo Sacral (Ap)",  
      price: 375
   },
  {id: 70,
      test:"X-Ray Lumbo Sacral ( R Lat )",  
      price: 375
   },
  {id: 71,
      test:"X-Ray Lumbo Sacral ( L Lat)",  
      price: 375
   },
  {id: 72,
      test:"X-Ray Lumbo Sacral (Ro)",  
      price: 375
   },
  {id: 73,
      test:"X-Ray Lumbo Sacral (Lo)",  
      price: 375
   },
  {id: 74,
      test:"X-Ray Lumbo Sacral Spine Flexion / Extension",  
      price: 375
   },
  {id: 75,
      test:"X-Ray Sacro Coccyx ( Ap )",  
      price: 375
   },
  {id: 76,
      test:"X-Ray Sacro Coccyx (Lat)",  
      price: 375
   },
  {id: 77,
      test:"X Ray Lumbar Spine (Ap & Lat)",  
      price: 735
   },
  {id: 78,
      test:"X-Ray Coccyx (Ap & Lat)e",  
      price: 735
   },
  {id: 79,
      test:"X-Ray Sacro-Coccyx (Ap & Lat)",  
      price: 735
   },
  {id: 80,
      test:"X-Ray Thoracic Spine (Ap & Lat)",  
      price: 735
   },
  {id: 81,
      test:"X-Ray Sternum ( Ap )",  
      price: 375
   },
  {id: 82,
      test:"X-Ray Sternum (Ro)",  
      price: 375
   },
  {id: 83,
      test:"X-Ray Sternum (Lo)",  
      price: 375
   },
  {id: 84,
      test:"X-Ray Sterno Clavicular Joint (Ap)",  
      price: 735
   },
  {id: 85,
      test:"X-Ray Skull ( Ap )",  
      price: 375
   },
  {id: 86,
      test:"X-Ray Skull ( R Lat )",  
      price: 375
   },
  {id: 87,
      test:"X-Ray Skull ( L Lat )",  
      price: 375
   },
  {id: 88,
      test:"X-Ray Skull ( Towne )",  
      price: 375
   },
  {id: 89,
      test:"X-Ray Skull ( Base Of Skull )",  
      price: 375
   },
  {id: 90,
      test:"X-Ray Skull (Ap &Lat)",  
      price: 735
   },
  {id: 91,
      test:"X-Ray Right Shoulder ( Ap)",  
      price: 375
   },
  {id: 92,
      test:"X-Ray Right Shoulder ( Lat)",  
      price: 375
   },
  {id: 93,
      test:"X-Ray Right Shoulder ( Axial)",  
      price: 375
   },
  {id: 94,
      test:"X-Ray Right Clavicle ( Ap)",  
      price: 375
   },
  {id: 95,
      test:"X-Ray Right Arm (Ap )",  
      price: 375
   },
  {id: 96,
      test:"X-Ray Right Arm ( Lat)",  
      price: 375
   },
  {id: 97,
      test:"X-Ray Sterno Clavicular Joint (Ap)",  
      price: 375
   },
  {id: 98,
      test:"X-Ray Right Elbow Joint ( Ap)",  
      price: 375
   },
  {id: 99,
      test:"X-Ray Right Elbow Joint ( Lat )",  
      price: 375
   },
  {id: 100,
      test:"X-Ray Right Forearm ( Ap)",  
      price: 375
   },
  {id: 101,
      test:"X-Ray Right Forearm ( Lat )",  
      price: 375
   },
  {id: 102,
      test:"X-Ray Right Hand (Ap)",  
      price: 375
   },
  {id: 103,
      test:"X-Ray Right Hand (Lat)",  
      price: 375
   },
  {id: 104,
      test:"X-Ray Right Hand ( Oblique)",  
      price: 375
   },
  {id: 105,
      test:"X-Ray Right Wrist ( Ap)",  
      price: 375
   },
  {id: 106,
      test:"X-Ray Right Wrist ( Lat)",  
      price: 375
   },
  {id: 107,
      test:"X-Ray Left Shoulder Ap",  
      price: 375
   },
  {id: 108,
      test:"X-Ray Left Shoulder (Lat )",  
      price: 375
   },
  {id: 109,
      test:"X-Ray Left Shoulder ( Axial)",  
      price: 375
   },
  {id: 110,
      test:"X-Ray Left Clavicle (Ap)",  
      price: 375
   },
  {id: 111,
      test:"X-Ray Left Arm (Ap)",  
      price: 375
   },
  {id: 112,
      test:"X-Ray Left Arm ( Lat )",  
      price: 375
   },
  {id: 113,
      test:"X-Ray Left Elbow Joint (Ap)",  
      price: 375
   },
  {id: 114,
      test:"X-Ray Left Elbow Joint (Lat)",  
      price: 375
   },
  {id: 115,
      test:"X-Ray Left Forearm (Ap)",  
      price: 375
   },
  {id: 116,
      test:"X-Ray Left Forearm (Lat)",  
      price: 375
   },
  {id: 117,
      test:"X-Ray Left Hand ( Ap )",  
      price: 375
   },
  {id: 118,
      test:"X-Ray Left Hand ( Lat )",  
      price: 375
   },
  {id: 119,
      test:"X-Ray Left Hand ( O)",  
      price: 375
   },
  {id: 120,
      test:"X-Ray Both Hands (Ap)",  
      price: 375
   },
  {id: 121,
      test:"X-Ray Left Wrist (Ap)",  
      price: 375
   },
  {id: 122,
      test:"X-Ray Left Wrist (Lat)",  
      price: 375
   },
  {id: 123,
      test:"X-Ray Both Wrists (Ap)",  
      price: 375
   },
  {id: 124,
      test:"X-Ray Foot (Ap & Lat)",  
      price: 735
   },
  {id: 125,
      test:"X-Ray Finger Ap &Lat",  
      price: 735
   },
  {id: 126,
      test:"X-Ray Both Patella (Skyline )",  
      price: 375
   },
  {id: 127,
      test:"X Ray Wrist (Ap & Lat_)",  
      price: 735
   },
  {id: 128,
      test:"X-Ray Right Wrist (Ap & Lat)",  
      price: 735
   },
  {id: 129,
      test:"X-Ray Thumb Ap & Lat",  
      price: 735
   },
  {id: 130,
      test:"X-Ray Both Hands (Ap & Lat)",  
      price: 735
   },
  {id: 131,
      test:"X-Ray Both Wrists (Ap & Lat)",  
      price: 735
   },
  {id: 132,
      test:"X-Ray Foot (Ap & O)",  
      price: 735
   },
  {id: 133,
      test:"X-Ray Right Elbow (Ap & Lat)",  
      price: 735
   },
  {id: 134,
      test:"X-Ray Both Shoulders (Ap &Lat)",  
      price: 1386
   },
  {id: 135,
      test:"X-Ray Humerus (Ap & Lat)t",  
      price: 735
   },
  {id: 136,
      test:"X-Ray Left Hip Joint (Ap & Lat)",  
      price: 735
   },
  {id: 137,
      test:"X-Ray Right Arm (Ap & Lat)",  
      price:735
   },
  {id: 138,
      test:"X-Ray Left Arm (Ap & Lat)",  
      price: 735
   },
  {id: 139,
      test:"X-Ray Left Wrist (Ap &Lat)",  
      price: 735
   },
  {id: 140,
      test:"X-Ray Kub (Fasting With Preparation )",  
      price: 735
   },
  {id: 141,
      test:"X-Ray Abdomen ( Erect )",  
      price: 375
   },
 
  {id: 142,
      test:"X-Ray Abdomen (Supine)",  
      price: 375
   },
  {id: 143,
      test:"X-Ray Pelvis (Ap)",  
      price: 375
   },
  {id: 144,
      test:"X-Ray Pelvis (Frog View)",  
      price: 375
   },
  {id: 145,
      test:"X-Ray Both Sacro-Iliac Joints (O)",  
      price: 375
   },
  {id: 146,
      test:"X-Ray Right Sacro-Iliac Joint (O)",  
      price: 375
   },
  {id: 147,
      test:"X-Ray Right Hip Joint (Ap)",  
      price: 375
   },
  {id: 148,
      test:"X-Ray Right Hip Joint ( Lat )",  
      price: 375
   },
  {id: 149,
      test:"X-Ray Right Thigh ( Ap)",  
      price: 375
   },
  {id: 150,
      test:"X-Ray Right Thigh ( Lat)",  
      price: 375
   },
  {id: 151,
      test:"X-Ray Right Knee Joint ( Ap )",  
      price: 375
   },
  {id: 152,
      test:"X-Ray Right Knee Joint ( Lat)",  
      price: 375
   },
  {id: 153,
      test:"X-Ray Right Leg ( Ap)",  
      price: 375
   },
  {id: 154,
      test:"X-Ray Right Leg ( Lat)",  
      price: 375
   },
  {id: 155,
      test:"X-Ray Right Ankle ( Ap)",  
      price: 375
   },
  {id: 156,
      test:"X-Ray Right Ankle ( Lat)",  
      price: 375
   },
  {id: 157,
      test:"X-Ray Right Ankle (Ro)",  
      price: 375
   },
  {id: 158,
      test:"X-Ray Right Ankle ( Lo)",  
      price: 375
   },
  {id: 159,
      test:"X-Ray Right Foot ( Ap)",  
      price: 375
   },
  {id: 160,
      test:"X-Ray Right Foot ( O )",  
      price: 375
   },
  {id: 161,
      test:"X-Ray Left Sacro-Iliac Joint (O)",  
      price: 375
   },
  {id: 162,
      test:"X-Ray Left Hip Joint (Ap)",  
      price: 375
   },
  {id: 163,
      test:"X-Ray Left Hip Joint ( Lat)",  
      price: 375
   },
  {id: 164,
      test:"X-Ray Left Thigh (Lat)",  
      price: 375
   },
  {id: 165,
      test:"X-Ray Left Thigh (Ap)",  
      price: 375
   },
  {id: 166 ,
      test:"X-Ray Left Knee Joint (Ap)",  
      price: 375
   },
  {id: 167,
      test:"X-Ray Left Knee Joint(Lat)",  
      price: 375
   },
  {id: 168,
      test:"X-Ray Left Leg (Ap)",  
      price: 375
   },
  {id: 169,
      test:"X-Ray Left Leg ( Lat)",  
      price: 375
   },
  {id: 170,
      test:"X-Ray Left Ankle (Ap )",  
      price: 375
   },
  {id: 171,
      test:"X-Ray Left Ankle ( Lat )",  
      price: 375
   },
  {id: 172,
      test:"X-Ray Left Ankle ( Ro)",  
      price: 375
   },
  {id: 172,
      test:"X-Ray Left Ankle (Lo)",  
      price: 375
   },
  {id: 173,
      test:"X-Ray Left Foot (Ap)",  
      price: 375
   },
  {id: 174,
      test:"X-Ray Left Foot (O)",  
      price: 375
   },
  {id: 175,
      test:"X-Ray Both Knee (Ap) Standing",  
      price: 375
   },
  {id: 176,
      test:"X-Ray Both Heels (Lat)",  
      price: 375
   },
  {id: 177,
      test:"X-Ray Both Heels ( Axial)",  
      price: 375
   },
  {id: 178,
      test:"X-Ray Intracondylar Notch",  
      price: 375
   },
  {id: 179,
      test:"X-Ray Skyline (Patella)",  
      price: 375
   },
  {id: 180,
      test:"X-Ray Both Hip Joints (Ap & Lat)",  
      price: 1050
   },
  {id: 181,
      test:"X-Ray Both Ankles (Ap)",  
      price: 375
   },
  {id: 182,
      test:"X-Ray Toe (Ap & Lat)",  
      price: 735
   },
  {id: 183,
      test:"X-Ray Both Legs (Ap & Lat)",  
      price: 375
   },
  {id: 184,
      test:"X-Ray Sacro Iliac Joints (Ap & O)",  
      price: 375
   },
  {id: 185,
      test:"X- Ray Femur",  
      price: 375
   },
  {id: 186,
      test:"X-Ray Right Hip Joint (Ap & Lat)",  
      price: 755
   },
  {id: 187,
      test:"X-Ray Both Calcaneum (Ap)",  
      price: 375
   },
  {id: 188,
      test:"X-Ray Sacr0 Iliac Joint (Ap)",  
      price: 375
   },
  {id: 189,
      test:"X-Ray Leg (Ap & Lat)",  
      price: 735
   },
  {id: 190,
      test:"X-Ray Thigh (Ap & Lat)",  
      price: 735
   },
  {id: 191,
      test:"X-Ray Left Ankle With Foot (Ap)",  
      price: 375
   },
  {id: 192,
      test:"X-Ray Right Ankle With Foot (Ap)",  
      price: 375
   },
  {id: 193,
      test:"X-Ray Both Feet (Ap & Lat)h",  
      price: 735
   },
  {id: 194,
      test:"X-Ray Adenoids (Nasopharynx)",  
      price: 350
   },
  {id: 195,
      test:"X-Ray Neck (Ap & Lat)",  
      price: 735
   },
  {id: 196,
      test:"X-Ray Neck (Ap)",  
      price: 375
   },
  {id: 197,
      test:"X-Ray Neck (Lat)",  
      price: 375
   },
  {id: 198,
      test:"X-Ray Mandible (Ap)",  
      price: 375
   },
  {id: 199,
      test:"X-Ray Mandible (R Lat)",  
      price: 375
   },
  {id: 200,
      test:"X-Ray Mandible (L Lat)",  
      price: 375
   },
  {id: 201,
      test:"X-Ray Mandible (Ro)",  
      price: 375
   },
  {id: 202,
      test:"X-Ray Mandible (Lo)",  
      price: 375
   },
  {id: 203,
      test:"X-Ray Mastoids ( Lat)",  
      price: 375
   },
  {id: 204,
      test:"X-Ray Tm Joint Open Mouth (R)",  
      price: 375
   },
  {id: 205,
      test:"X-Ray Tm Joint Open Mouth (L)",  
      price: 375
   },
  {id: 206,
      test:"X-Ray Tm Joint Closed Mouth (R)",  
      price: 375
   },
  {id: 207,
      test:"X-Ray Tm Joint Closed Mouth (L)",  
      price: 375
   },
  {id: 208,
      test:"X-Ray Tm Joint (O)",  
      price: 375
   },
  {id: 209,
      test:"X-Ray Nasal Bone ( Lat)",  
      price: 375
   },
  {id: 210,
      test:"X-Ray Orbit",  
      price: 375
   },
  {id: 211,
      test:"X-Ray Pns",  
      price: 375
   },
  {id: 212,
      test:"X Ray Skull (Ap & Lat)",  
      price: 735
   },
  {id: 213,
      test:"X-Ray Both Mastoids (Lat)",  
      price: 375
   },
  {id: 214,
      test:"X-Ray Neck Styloid Process",  
      price: 735
   },
  {id: 215,
      test:"X-Ray Orbit (Ap & Lat)",  
      price: 735
   },
  {id: 216,
      test:"X-Ray Face / Neck)",  
      price: 300
   },
  {id: 217,
      test:"X-Ray Mastoid (R Lat O)",  
      price: 375
   },
  {id: 218,
      test:"Sinogram",  
      price: 3000
   },
  {id: 219,
      test:"Fistulogram",  
      price: 2940
   },
  {id: 220,
      test:"Hysterosalpingography",  
      price: 3990
   },
  {id: 221,
      test:"Barium Meal Follow Through Exam",  
      price: 3675
   },
  {id: 222,
      test:"Barium Enema",  
      price: 3675
   },
  {id: 223,
      test:"Barium Swallow",  
      price: 2900
   },
  {id: 224,
      test:"Barium Meal Studies",  
      price: 2940
   },
  {id: 225,
      test:"T. Tube Cholangiogram",  
      price: 2625
   },
  {id: 226,
      test:"Intra Venous Urography ( Ivu / Ivp ) With Contrast",  
      price: 4725
   },
  {id: 227,
      test:"Reterograde Urethrogram ( Rgu )",  
      price: 2940
   },
  {id: 228,
      test:"Micturating Cystourethrogram ( Mcu)",  
      price: 3675
   },
  {id: 229,
      test:"Distal Loopgram",  
      price: 3990
   },
  {id: 230,
      test:"Contrast Charges -Ii",  
      price: 840
   },
  {id: 231,
      test:"Ecg / Ekg (Electrocardiography )",  
      price: 290
   },
  {id: 232,
      test:"Echocardiography",  
      price: 2625
   },
  {id: 233,
      test:"Tmt",  
      price: 2625
   },
   
]


export default rediologyTest;
